import { UseCase } from '@/core/base/use-case';
import { Observable } from 'rxjs';
import {
    CartStep2ProductInterface,
    CartStep2ProductResponseInterface,
} from '../models/cart-step2-product.model';
import { CartStep2ProductRepository } from '../repositories/cart-step2-product.repository';

export class sendCartStep2ProductUseCase
    implements
        UseCase<CartStep2ProductInterface, CartStep2ProductResponseInterface>
{
    constructor(private readonly repository: CartStep2ProductRepository) {}

    execute(
        array: CartStep2ProductInterface,
    ): Observable<CartStep2ProductResponseInterface> {
        return this.repository.sendCartStep2Product(array);
    }
}
